import { createApp } from 'vue';
import App from '@admin/App.vue';
import { createRouter } from '@admin/router/index';
import '@spectee/assets/css/reset.css';
import '@spectee/assets/css/global.css';
import { createAccountApi } from '@admin/plugins/accountApi';
import { createAuth0, Auth0VueClientOptions } from '@auth0/auth0-vue';
import type { InMemoryCacheConfig } from '@apollo/client/core';
import ElementPlus from 'element-plus';
import ja from 'element-plus/es/locale/lang/ja';

export const typePolicies: InMemoryCacheConfig['typePolicies'] = {
  Spot: {
    keyFields: ['code'],
    fields: {
      incidents: {
        merge: false,
      },
      recentIncidents: {
        merge: false,
      },
    },
  },
  Parts: {
    keyFields: ['code'],
  },
  EnqueteElement: {
    keyFields: ['orderId'],
  },
  ArticleDetail: {
    keyFields: ['incidentId'],
  },
  EarthquakeDetail: {
    keyFields: ['incidentId'],
  },
};

const auth0ClientOptions: Auth0VueClientOptions = {
  domain: import.meta.env.VITE_APP_DOMAIN ?? '',
  clientId: import.meta.env.VITE_APP_CLIENT_ID ?? '',
  authorizationParams: {
    redirect_uri: `${window.location.origin}/`,
  },
  cookieDomain: '.spectee.com',
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
};

const app = createApp(App)
  .use(createRouter())
  .use(createAuth0(auth0ClientOptions))
  .use(
    createAccountApi({
      endpoint: import.meta.env.VITE_APP_APPSYNC_GRAPHQL_ENDPOINT,
      apolloClientOptions: {
        connectToDevTools: import.meta.env.MODE === 'development',
      },
      inMemoryCacheConfig: { typePolicies },
    })
  )
  .use(ElementPlus, { locale: ja })
  .mount('#app');
export { app };
